<template>
  <ValidationObserver ref="observer">
    <div class="card centered bg-light">
      <h1 class="card-header bg-primary">
        {{ $t("authent.login.title") }}
      </h1>
      <form @submit.prevent="checkFormValidity">
        <b-alert :show="errorMessage != null" fade variant="danger">
          {{ errorMessage }}
        </b-alert>

        <BTextInputWithValidation
          v-model="email"
          label-cols-sm="3"
          :rules="`required|email`"
          maxlength="254"
          type="text"
          :label="$t('mail')"
          name="Email"
        />

        <BTextInputWithValidation
          v-model="password"
          rules="required"
          label-cols-sm="3"
          maxlength="254"
          type="password"
          :label="$t('password')"
          name="Password"
        />

        <div class="clearfix">
          <b-button
            variant="outline-primary"
            class="floating right"
            type="submit"
            :disabled="isLoading"
          >
            <div v-if="!isLoading">
              <font-awesome-icon icon="sign-in-alt" />
              <span class="pl-2">{{ $t("authent.login.login") }}</span>
            </div>
            <b-icon v-else icon="three-dots" animation="cylon" />
          </b-button>
        </div>
      </form>
    </div>
  </ValidationObserver>
</template>
<script>
import { get } from "lodash";
import BTextInputWithValidation from "@/components/inputs/BTextInputWithValidation";
import { ValidationObserver } from "vee-validate";
import { HOME, LOGIN } from "@/router/routeNames";

export default {
  name: LOGIN,
  components: {
    ValidationObserver,
    BTextInputWithValidation,
  },
  model: {
    prop: "form",
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      email: "",
      password: "",
    };
  },
  mounted() {
    if (this.$store.getters["authentication/isAuthenticated"]) {
      this.$router.push(this.$route.query.redirectFrom || { name: HOME });
    }
  },
  methods: {
    checkFormValidity() {
      this.$refs.observer.validate().then(async (valid) => {
        if (valid) {
          await this.handleSubmit();
        }
      });
    },
    redirectToHome() {
      this.$router.push({ name: HOME });
    },
    async handleSubmit() {
      this.isLoading = true;
      this.errorMessage = null;
      const data = new URLSearchParams();
      data.append("grant_type", "password");
      data.append("scope", "API offline_access profile openid");
      data.append("username", this.email);
      data.append("password", this.password);

      try {
        await this.$store.dispatch("authentication/signIn", {
          email: this.email,
          password: this.password,
        });

        setTimeout(() => {
          this.$router
            .push(this.$route.query.redirectFrom || { name: HOME })
            .catch(() => {});
          this.isLoading = false;
        }, 1500);
      } catch (e) {
        const errorDescription = get(
          e.response,
          "data.error_description",
          "invalid_username_or_password"
        );

        const errorKey = `authent.login.errors.${errorDescription}`;

        setTimeout(() => {
          this.errorMessage = this.$t(errorKey);
          this.isLoading = false;
        }, 500);
      }
    },
  },
};
</script>

<style lang="scss">
.centered {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  min-width: 20%;
  max-width: 600px;

  h1 {
    color: white;
  }

  form {
    margin: 20px;
  }

  legend {
    text-align: left;
  }
}

.floating.left {
  float: left;
}

.floating.right {
  float: right;
}

.clearfix::after {
  content: " ";
  display: block;
  height: 0;
  clear: both;
}
</style>
